export const BASEURL = "https://backend-omega-roan.vercel.app/api/v1"
